import { User, FileText, Users, Building, Lock, Briefcase, BarChart3, Home, FileCheck, ClipboardList, Receipt, Package } from "lucide-react";

export const profileConfigs = {
    client: {
        role: "client",
        tabs: [
            { id: "personal", label: "Personal Info", icon: <User className="w-5 h-5" /> },
            { id: "forms", label: "My Forms", icon: <FileText className="w-5 h-5" /> },
            { id: "packages", label: "My Packages", icon: <Package className="w-5 h-5" /> },
            { id: "ticket", label: "My Ticket", icon: <ClipboardList className="w-5 h-5" /> },
            { id: "clientRequestChat", label: "Request Chat (Notes)", icon: <ClipboardList className="w-5 h-5" /> },
            { id: "password", label: "Change Password", icon: <Lock className="w-5 h-5" /> },
        ],
    },
    lawyer: {
        role: "lawyer",
        tabs: [
            { id: "personal", label: "Personal Info", icon: <User className="w-5 h-5" /> },
            { id: "myCustomer", label: "My Customer", icon: <Users className="w-5 h-5" /> },
            { id: "myParalegals", label: "My Paralegals", icon: <Users className="w-5 h-5" /> },
            { id: "lawyerCreateClientRequest", label: "Lawyer Create Client Request", icon: <Users className="w-5 h-5" /> },
            { id: "lawyerCreateClient", label: "Lawyer Create Client", icon: <Users className="w-5 h-5" /> },
            { id: "lawyerRequestChat", label: "Request Chat (Notes)", icon: <Users className="w-5 h-5" /> },
            { id: "password", label: "Change Password", icon: <Lock className="w-5 h-5" /> },
        ],
    },
    office_owner: {
        role: "office_owner",
        tabs: [
            { id: "dashboard", label: "Dashboard", icon: <Home className="w-5 h-5" /> },
            { id: "personal", label: "Personal Info", icon: <User className="w-5 h-5" /> },
            { id: "officeDetails", label: "Office Details", icon: <Building className="w-5 h-5" /> },
            { id: "myLawyers", label: "My Lawyers", icon: <Users className="w-5 h-5" /> },
            { id: "analytics", label: "Office Analytics", icon: <BarChart3 className="w-5 h-5" /> },
            { id: "oficeLawyerRequests", label: "Ofice Lawyer Requests", icon: <FileCheck className="w-5 h-5" /> },
            { id: "officeCreateClient", label: "Office Create Client", icon: <FileCheck className="w-5 h-5" /> },
            { id: "officeCreateClientRequest", label: "Office Create Client Request", icon: <FileCheck className="w-5 h-5" /> },
            { id: "subscriptions", label: "Subscriptions", icon: <Receipt className="w-5 h-5" /> },
            { id: "caseTypes", label: "Case Types", icon: <Briefcase className="w-5 h-5" /> },
            { id: "password", label: "Change Password", icon: <Lock className="w-5 h-5" /> },
        ],
    },
    paralegal: {
        role: "paralegal",
        tabs: [
            { id: "dashboard", label: "Dashboard", icon: <User className="w-5 h-5" /> },
            { id: "personal", label: "Personal Info", icon: <User className="w-5 h-5" /> },
            { id: "myRequests", label: "Paralegal My Requests", icon: <FileText className="w-5 h-5" /> },
            { id: "paralegaRequestChat", label: "Request Chat (Notes)", icon: <FileText className="w-5 h-5" /> },
            { id: "password", label: "Change Password", icon: <Lock className="w-5 h-5" /> },
        ],
    },
};